import React from 'react'
import {Row, Col, Button, Input} from 'reactstrap'
import PropTypes from 'prop-types'
import moment from 'moment'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const WeekCommencingSwitcher = ({weekCommencing, nextWeek, lastWeek, onLastWeek, onNextWeek, onWeekChange}) => {
    return (
        <div className="d-flex flex-row justify-content-between align-items-end pt-3 pb-3">
            <div>
                <Button
                    size="sm"
                    color="primary"
                    onClick={() => onLastWeek(lastWeek)}>
                    <FontAwesomeIcon
                        icon="chevron-left"
                    />{' '}
                    {moment(lastWeek).format('Do MMMM YYYY')}
                </Button>
            </div>
            <div className="d-flex flex-column align-items-center" >
                <h5 style={{textAlign: 'center'}}>w/c {moment(weekCommencing).format('Do MMMM YYYY')}</h5>
                <Input
                    size="sm"
                    type="date"
                    value={weekCommencing}
                    onChange={(evt) => onWeekChange(moment(evt.target.value).startOf('week').format('YYYY-MM-DD'))}
                />
            </div>
            <div>
                <Button
                    size="sm"
                    color="primary"
                    onClick={() => onNextWeek(nextWeek)}>{moment(nextWeek).format('Do MMMM YYYY')}{' '}
                    <FontAwesomeIcon
                        icon="chevron-right"
                    />
                </Button>
            </div>
        </div>
    )
}

export default WeekCommencingSwitcher

WeekCommencingSwitcher.propTypes = {
    nextWeek: PropTypes.string.isRequired,
    lastWeek: PropTypes.string.isRequired,
    weekCommencing: PropTypes.string.isRequired,
    onLastWeek: PropTypes.func,
    onNextWeek: PropTypes.func
}